import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },

  username: {
    fontWeight: 'bold',
    textAlign: 'left',
    padding: theme.spacing(1, 2, 1, 2),

    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },

  country: {
    textAlign: 'left',
    padding: theme.spacing(1, 2, 1, 2),

    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
      padding: theme.spacing(0, 2, 1, 2),
    },
  },

  socialLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(1, 2, 1, 2),
  },

  player: {
    display: 'flex',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'end',

    [theme.breakpoints.down('lg')]: {
      justifyContent: 'center',
    },
  },

  button: {
    width: theme.spacing(18.75),
    height: theme.spacing(4.5),
    marginRight: theme.spacing(1),

    '&:last-child': {
      marginRight: theme.spacing(0),
    },
  },

  bioContainer: {
    marginTop: theme.spacing(1),
  },
}));
